<template>
  <div class="full-screen reports-section" v-bind:style="{ backgroundImage: 'url(' + `${user.data.otherInfo['bg-img']}` + ')'}">
    <div class="app-bg-gradient">
    <div class="stars-bg"></div>
    <div class="cursor back" @click="movetoHome">{{"Back" | translate}}</div>
    <div class="heighlights-section" v-if="allTransactions">
      <div class="view-heighlight" style="display:none;">
        <div>
          <span>{{"Last Month" | translate}}</span>
          <span>&#163; {{allTransactions.lastMonth}}</span>
        </div>
      </div>
      <div class="view-heighlight">
        <div>
          <span>{{"Today" | translate}} </span>
          <span>&#163; {{allTransactions.today}}</span>
        </div>
      </div>
      <div class="view-heighlight">
        <div>
          <span>{{"This Week" | translate}}</span>
          <span>&#163; {{allTransactions.week}}</span>
        </div>
      </div>
      <div class="view-heighlight">
        <div>
          <span>{{"This Month" | translate}}</span>
          <span>&#163; {{allTransactions.month}}</span>
        </div>
      </div>
    </div>
    <div class="detailed-transactions">
      <div class="sort-section">
        <div>
          <div>
            {{"Category" | translate}}
            <!--{{user}}-->
            <select v-model="category">
              <option value="All">{{"All" | translate}}</option>
              <option :value="option.title" v-if="option.title !== 'Other Donations'" :key="option.title" v-for="option in user.data.donationCategories">{{option.title | translate}}</option>
              <optgroup v-if="option.title === 'Other Donations'" :key="option.title" v-for="option in user.data.donationCategories" :label="option.title | translate">
                  <option :value="category.title" :key="category.title" v-for="category in option.childCategories">{{category.title | translate}}</option>
              </optgroup>
            </select>
          </div>
          <div>
            {{"Show by" | translate}}
            <select v-model="showBy">
              <option value="today">{{"Today" | translate}}</option>
              <option value="week">{{"Week" | translate}}</option>
              <option value="month">{{"Month" | translate}}</option>
              <option value="range">{{"Range" | translate}}</option>
            </select>
          </div>
          <div v-if="showBy === 'range'">
            <input type="date" v-model="rangeStartDate" :max="dateToday" @change="fromDateChange"/>
            <input type="date" v-model="rangeEndDate" :max="dateToday" :min="minToDate" @change="toDateChange"/>
          </div>
          <div>
            {{"Status" | translate}}
            <select v-model="status">
              <option value="All">{{"All" | translate}}</option>
              <option value="SUCCESSFUL">{{"Success" | translate}}</option>
              <option value="notSuccess">{{"Failed" | translate}}</option>
            </select>
          </div>
          <div class="btn-bg1">
            <div class="btn-bg2">
              <button @click="categoryChange" class="cursor login">{{"View" | translate}}</button>
            </div>
          </div>
        </div>
        <div>
          <div class="btn-bg1 reports-btn">
            <div class="btn-bg2">
              <button @click="gotoEODReports" class="cursor login">{{"EOD Reports" | translate}}</button>
            </div>
          </div>
          <div class="btn-bg1">
            <div class="btn-bg2">
              <button @click="DownloadXl" class="cursor login">{{"Download" | translate}}</button>
            </div>
          </div>
        </div>
      </div>
      <div class="transaction-section">
        <div>
          <div class="transaction-data transaction-data-head">
            <div>{{"Transaction ID" | translate}}</div>
            <div>{{"Date Time" | translate}}</div>
            <div>{{"Donation Amount" | translate}}</div>
            <div>{{"Donation Type" | translate}}</div>
            <div>{{"Status" | translate}}</div>
          </div>
          <!--{{allTransactionsShow.length}}-->
          <div class="transition-data-section">
            <div class="transaction-data">
              <div></div>
              <div></div>
              <div>&#163;{{getTransactions.reduce((x, y) => x + y.amount, 0)}}</div>
              <div></div>
              <div></div>
            </div>
            <div class="transaction-data" v-for="donation in getTransactions" :key="donation.id" v-if="allTransactionsShow.length > 0">
              <div>{{donation.ps_reference | translate}}</div>
              <div>{{donation.dateString | translate}}</div>
              <div>&#163;{{donation.amount}}</div>
              <div>{{donation.type | translate}}</div>
              <div class="status" :class="donation.status"><span>{{donation.status | translate}}</span></div>
            </div>
          </div>
        </div>
        <div style="height:80%;" v-if="allTransactionsShow.length === 0" class="full-height flex-center">
          {{"No transactions found" | translate}}
        </div>
      </div>
    </div>
      </div>
      <div class="back-drop" v-if="rangeEmpty">
      </div>
      <div class="error-msg" v-if="rangeEmpty">
        {{rangeEmpty | translate}}
      </div>
    <!--{{reportsDetails}}-->
  </div>
</template>

<script>
import { mapGetters, mapActions } from 'vuex'
import moment from 'moment'

export default {
  data () {
    return {
      startOfDayEpoch: null,
      startOfWeekEpoch: null,
      startOfMonthEpoch: null,
      startOfLastMonthEpoch: null,
      transactionsList: null,
      allTransactions: {},
      showBy: 'today',
      previousView: 'today',
      category: 'All',
      status: 'SUCCESSFUL',
      allTransactionsShow: [],
      rangeStartDate: null,
      rangeEndDate: null,
      rangeStartDateEpoch: null,
      rangeEndDateEpoch: null,
      statusCheck: null,
      viewChanges: false,
      dateToday: null,
      minToDate: null,
      rangeChange: false,
      tid: null,
      transactionTotalList: null,
      rangeEmpty: null
    }
  },
  computed: {
    ...mapGetters([
      'user',
      'token',
      'reportsDetails'
    ]),
    getTransactions () {
      if (this.viewChanges) {
        if (this.status === 'All') {
          return this.allTransactionsShow || []
        } else if (this.status === 'SUCCESSFUL') {
          return this.allTransactionsShow.filter(a => a.status === 'SUCCESSFUL')
        } else if (this.status !== 'SUCCESSFUL') {
          return this.allTransactionsShow.filter(a => a.status !== 'SUCCESSFUL')
        }
      } else {
        return this.allTransactionsShow
      }
    }
  },
  created: function () {
    this.startOfDayEpoch = +moment().startOf('day')
    this.startOfWeekEpoch = +(moment().startOf('week')._d)
    this.startOfMonthEpoch = +(moment().startOf('month')._d)
    this.startOfLastMonthEpoch = +moment().subtract(1, 'months').date(1).startOf('day')
    this.dateToday = moment(new Date()).format('YYYY-MM-DD')
    this.endOfToday = +(moment().endOf('day')._d)
    // console.log(this.dateToday)
  },
  methods: {
    ...mapActions([
      'changeLoadingStatus',
      'getReportsRange'
    ]),
    changeViewStatus () {
      this.viewChanges = false
      // console.log(this.viewChanges)
    },
    movetoHome () {
      this.$router.push({path: `/${this.tid}/home`})
    },
    fromDateChange () {
      this.rangeEndDate = null
      this.minToDate = this.rangeStartDate
      this.rangeChange = true
    },
    toDateChange () {
      this.rangeChange = true
    },
    DownloadXl () {
      let ShowLabel = true
      let JSONData = JSON.parse(JSON.stringify(this.allTransactionsShow))
      let filename = this.rangeStartDate + 'to' + this.rangeEndDate
      if (JSONData.length === 0) {
        return
      }
      Object.keys(JSONData).map((keys) => {
        delete JSONData[keys]['date']
      })
      var arrData = (typeof JSONData !== 'object') ? JSON.parse(JSONData) : JSONData
      var CSV = ''
      if (ShowLabel) {
        // var row = ''
        // // This loop will extract the label from 1st index1 of on array
        // for (var index in arrData[0]) {
        // // Now convert each value to string and comma-seprated
        //   row += index + ','
        // }
        // row = row.slice(0, -1)
        // // append Label row with line break
        // CSV += row + '\r\n'
        CSV += 'Donation Type, Status, Transaction Id, Donation Amount, Date Time' + '\r\n\n'
      }
      let csvData = []
      // console.log(CSV)
      arrData.map(record => {
        // console.log(record)
        Object.keys(record).map((keys) => {
          if (keys !== 'ps_reference' && keys !== 'dateString' && keys !== 'amount' && keys !== 'type' && keys !== 'status') {
            delete record[keys]
          }
        })
        csvData.push(record)
      })
      // console.log(csvData)
      // 1st loop is to extract each row
      for (var i = 0; i < csvData.length; i++) {
        // console.log()
        var row1 = ''
        // 2nd loop will extract each column and convert it in string comma-seprated
        for (var index1 in csvData[i]) {
          row1 += '"' + csvData[i][index1] + '",'
        }
        row1.slice(0, row1.length - 1)
        // add a line break after each row1
        CSV += row1 + '\r\n'
      }
      if (CSV === '') {
        alert('Invalid data')
        return
      }
      // Generate a file name
      var fileName = this.user.data.name
      // this will remove the blank-spaces from the title and replace it with an underscore
      fileName += filename.replace(/ /g, '_')
      // Initialize file format you want csv or xls
      var uri = 'data:text/csv;charset=utf-8,' + escape(CSV)
      //  Now the little tricky part.
      //  you can use either>> window.open(uri);
      //  but this will not work in some browsers
      //  or you will not get the correct file extension
      // this trick will generate a temp <a /> tag
      var link = document.createElement('a')
      link.href = uri
      // set the visibility hidden so it will not effect on your web-layout
      link.style = 'visibility:hidden'
      link.download = fileName + '.csv'
      // this part will append the anchor tag and remove it after automatic click
      document.body.appendChild(link)
      link.click()
      document.body.removeChild(link)
      // console.log(csvData, CSV)
      // setTimeout(() => {
      //   location.reload()
      // }, 100)
    },
    categoryChange () {
      this.viewChanges = true
      if (this.showBy === 'range') {
        if (this.rangeStartDate && this.rangeEndDate && (this.rangeStartDate <= this.rangeEndDate)) {
          this.rangeStartDateEpoch = +(moment(this.rangeStartDate).startOf('day')._d)
          this.rangeEndDateEpoch = +(moment(this.rangeEndDate).endOf('day')._d)
        } else {
          this.rangeEmpty = 'Please select a range'
          setTimeout(() => {
            this.rangeEmpty = false
          }, 2000)
          return
        }
      } else {
        this.rangeStartDate = null
        this.rangeEndDate = null
        this.rangeStartDateEpoch = null
        this.rangeEndDateEpoch = null
      }
      if (this.previousView === this.showBy && !this.rangeChange) {
        this.filterTransactions()
      } else {
        this.rangeChange = false
        let range = {}
        if (this.showBy === 'range') {
          range['from'] = this.rangeStartDateEpoch
          range['to'] = this.rangeEndDateEpoch
        } else if (this.showBy === 'week') {
          range['from'] = this.startOfWeekEpoch
          range['to'] = this.endOfToday
        } else if (this.showBy === 'month') {
          range['from'] = this.startOfMonthEpoch
          range['to'] = this.endOfToday
        } else {
          range['from'] = this.startOfDayEpoch
          range['to'] = this.endOfToday
        }
        this.getReportsRange(range)
        .then((res) => {
          this.getAllReports()
        })
        .catch(error => {
          console.log(error)
        })
      }
      setTimeout(() => {
        this.viewChanges = false
      }, 500)
      this.previousView = this.showBy
    },
    filterTransactions () {
      var vm = this
      vm.allTransactionsShow = vm.transactionTotalList.filter(record => {
        // console.log(record)
        if (vm.category === 'All' || record.type === vm.category) {
          let r = vm.checkSortBy(record, vm.showBy, vm.status)
          return r
        }
      })
      // console.log(vm.allTransactionsShow)
    },
    checkSortBy (r, s, status) {
      let record
      if (status === 'All' || (status !== 'SUCCESSFUL' && r.status !== 'SUCCESSFUL')) {
        status = r.status
      }
      this.statusCheck = status
      let tTime = r.transactionTime
      if (s === 'today' && tTime >= (this.startOfDayEpoch) && status === r.status) {
        // console.log(r.transactionTime)
        // console.log(tTime)
        // console.log((this.startOfDayEpoch))
        record = r
      } else if (s === 'week' && tTime >= (this.startOfWeekEpoch) && status === r.status) {
        record = r
      } else if (s === 'month' && tTime >= (this.startOfMonthEpoch) && status === r.status) {
        record = r
      } else if (s === 'range' && (tTime >= this.rangeStartDateEpoch && tTime <= this.rangeEndDateEpoch) && status === r.status) {
        record = r
      } else {
        record = null
      }
      return record
    },
    gotoEODReports () {
      this.$router.push({path: `/${this.tid}/eodReports`})
    },
    checkReports () {
      this.allTransactions = this.todaysDonation()
    },
    todaysDonation () {
      let list = {'today': 0, 'week': 0, 'month': 0, 'lastMonth': 0}
      if (this.transactionsList) {
        this.transactionsList.filter(a => a.status === 'SUCCESSFUL').map((transaction) => {
          // console.log(transaction.transactionTime)
          let tTime = transaction.transactionTime
          if (((tTime)) >= this.startOfDayEpoch) {
            list.today = list.today + transaction.amount
          }
          if (((tTime)) >= this.startOfWeekEpoch) {
            list.week = list.week + transaction.amount
          }
          if (((tTime)) >= this.startOfMonthEpoch) {
            list.month = list.month + transaction.amount
          }
          if (((tTime)) >= this.startOfLastMonthEpoch && ((tTime) * 1000) < this.startOfMonthEpoch) {
            list.lastMonth = list.lastMonth + transaction.amount
          }
        })
      }
      this.categoryChange()
      return list
    },
    getAllReports () {
      let vm = this
      vm.transactionsList = this.reportsDetails.data
      Object.keys(this.transactionsList).map((keys) => {
        let val = vm.transactionsList[keys].transactionTime
        vm.transactionsList[keys]['dateString'] = moment(val).format('DD-MM-YYYY hh:mm A')
      })
      vm.allTransactionsShow = vm.transactionTotalList = vm.transactionsList
      // console.log(vm.allTransactionsShow)
      vm.checkReports()
    }
  },
  components: {
  },
  mounted: function () {
    this.tid = this.$route.params.terminalId
    this.$nextTick(() => {
      // Check wether the user has been already logged in.
      if (!this.token) {
        this.$router.push({path: `/${this.tid}/`})
      } else {
        // this.terminalId = (this.userPDQTerminals[0] || [{}]).tid
        this.changeLoadingStatus(false)
      }
    })
    let vm = this
    let from = +(moment().startOf('week')._d)
    let to = +(moment().endOf('week')._d)
    vm.getReportsRange({from, to}).then(() => {
      vm.getAllReports()
    })
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
    .reports-section {
        color: #FFF;
        height: 100vh;
        padding: 0;
    }
    .app-bg-gradient {
      padding: 25px 20px;
      height: 100%;
      overflow: hidden;
    }
    .heighlights-section {
      display: flex;
      margin-top: 30px;
      align-items: center;
      justify-content: space-around;
      z-index: 4;
      position: relative;
    }
    .view-heighlight {
      width: 22%;
      height: 120px;
      display: flex;
      align-items: center;
      justify-content: center;
      color: #880913;
      background-color: #FFF;
      margin-right: 10px;
      box-shadow: 0px 1px 10px rgba(0,0,0,0.05);
      border-radius: 3px;
      transition: box-shadow 0.2s linear 0s;
      border-radius: 20px;
    }

    .back {
      position: absolute;
      top: 20px;
      right: 50px;
      font-size: 20px;
      cursor: pointer;
      z-index: 4;
    }
    .view-heighlight:hover {
      box-shadow: 0px 3px 23px rgba(0,0,0,0.35)
    }
    .view-heighlight:last-child {
      margin-right: 0;
    }
    .view-heighlight div {
      display: flex;
      flex-direction: column;
      align-items: center;
    }
    .view-heighlight div span:first-child {
      color: #880913;
      font-size: 20px;
      margin-bottom: 10px;
      font-weight: 600;
      letter-spacing: 2px;
    }
    .view-heighlight div span:last-child {
      color: #ff971c;
      font-size: 20px;
      font-weight: bold;
    }
    .sort-section {
      display: flex;
      align-items: center;
      height: 40px;
      margin: 20px 0;
      justify-content: space-between;
    }
    select {
      background-position: 95% 60%;
    }
    .sort-section > div {
      display: flex;
      align-items: center;
    }
    .sort-section > div > div:not(:last-child) {
      display: flex;
      margin-right: 15px;
      align-items: center;
    }

    div[dir='rtl'] .sort-section > div > div:not(:last-child) {
      margin-right: initial;
      margin-left: 15px;
    }
    div[dir='rtl'] .sort-section > div:first-child select, div[dir='rtl'] .sort-section > div:first-child input {
      margin-left: initial;
      margin-right: 10px;
    }
    div[dir='rtl'] select {
      background-position: 5% 60%;
      padding: 0 10px 0 30px !important;
    }
    .sort-section > div:first-child select, .sort-section > div:first-child input {
      border: 1px solid #880913;
      background-color: transparent;
      border-radius: 0;
      height: 30px;
      padding: 0 30px 0 10px;
      outline: none;
      color: #FFF;
      margin-left: 5px;
    }
    select {
      appearance: none;
    }
    select option, select optgroup {
      margin: 40px;
      background: #880913;
      color: #fff;
      text-shadow: 0 1px 0 rgba(0, 0, 0, 0.4);
  }
  .btn-bg1 {
    margin-top: 0;
  }
  option:checked {
    background: #fdc498 linear-gradient(0deg, #fdc498 0%, #fdc498 100%);
    color: #880913;
  }
  .full-screen {
    background-position: 50%;
}
  select option:hover{ box-shadow: 0 0 10px 10px #e1358f inset; }
    .transaction-data {
      display: flex;
      align-items: center;
      box-sizing: border-box;
      padding: 0 10px;
      height: 40px;
      border-bottom: 1px solid #880913;
    }
    .transaction-data > div {
      width: 25%;
    }
    .transaction-section {
      border: 1px solid #880913;
      height: calc(100vh - 280px);
      box-sizing: border-box;
      overflow-x: hidden;
    }
    .transition-data-section {
      height: calc(100% - 50px);
      overflow: hidden;
      overflow-y: auto;
      width: 100%;
    }
    .transaction-data-failure > div:first-child {
      width: 18%;
    }
    .transaction-data-failure > div:nth-child(2) {
      width: 18%;
    }
    .transaction-data-failure > div:nth-child(2) {
      width: 18%;
    }
    .transaction-data-failure > div:nth-child(2) {
      width: 18%;
    }
    .transaction-data-failure > div:last-child {
      width: 28%;
    }
    .full-height {
        height: 100%;
    }
    .status > span {
      background-color: #ff971c;
      padding: 5px;
      text-transform: lowercase;
    }
    .SUCCESSFUL > span {
      background-color: green !important;
      padding: 5px;
      text-transform: lowercase;
    }
    .btn-bg1 {
      width: 120px !important;
    }
    .btn-bg2 {
      width: 112px !important;
    }
    .btn-bg2 button.login {
      width: 110px !important;
    }
    .reports-btn.btn-bg1 {
      width: 140px !important;
    }
    .reports-btn .btn-bg2 {
      width: 132px !important;
    }
    .reports-btn .btn-bg2 button.login {
      width: 130px !important;
    }
    .transaction-data-head > div {
      color: #880913;
      font-weight: bold;
    }
    input[type="date"] {
      background-image: url('/static/images/drop-down-arrow.png');
      appearance: none;
      background-size : 14px;
      background-position: 90% 60%;
      background-repeat: no-repeat;
      padding-right: 10px !important;
    }
    input[type="date"]::-webkit-inner-spin-button,
    input[type="date"]::-webkit-calendar-picker-indicator {
        /* display: none; */
        -webkit-appearance: none;
    }
    input[type="date"]:hover {
      appearance: none;
    }
    .error-msg {
      position: absolute;
      width: 500px;
      height:150px;
      background-color: #FFF;
      border-radius: 50px;
      color: #880913;
      font-size: 18px;
      left: 0;
      right: 0;
      top: 0;
      bottom: 0;
      margin: auto;
    }
    .detailed-transactions {
      z-index: 4;
      position: relative;
    }
    @media only screen and (min-width: 2000px) {
      .heighlights-section {
        align-items: center;
        justify-content: space-around;
      }
      .reports-section {
        width: 100% !important;
        height: 100vh !important;
      }
      .view-heighlight {
        height: 400px;
        width: 20%;
      }
      .view-heighlight div span:first-child {
        font-size: 100px;
        line-height: 100px;
      }
      .view-heighlight div span:last-child {
        font-size: 80px;
        line-height: 80px;
      }
      .sort-section {
        height: 300px;
      }
      .sort-section > div > div:not(:last-child) {
        font-size: 80px;
        margin-right: 40px;
        line-height: 80px;
      }
      select {
        width: max-content;
        padding: 0 52px 0 21px !important;
        background-size : 30px;
      }
      input {
        background-size: 30px !important;
      }
      .sort-section > div:first-child select, .sort-section > div:first-child input {
        height: 100px;
        margin-left: 30px;
        font-size: 80px;
        line-height: 80px;
        border-width: 3px;
      }
      .btn-bg1 {
        margin-top: 0 !important;
      }
      .transaction-data {
        padding: 0 50px;
        min-height: 200px;
        height: inherit;
        border-width: 2px;
      }
      .transaction-data > div {
        width: 25%;
        font-size: 80px;
        padding-right: 20px;
        line-height: 80px;
      }
      .flex-center {
        font-size: 90px;
      }
      .detailed-transactions {
        width: 95%;
        margin: 0 auto;
        overflow-x: auto;
        z-index: 4;
        position: relative;
      }
      .transaction-section {
        height:74vh;
      }
      .full-height {
        height: 90%;
      }
      .reports-section {
        width: 100% !important;
        height: 100vh !important;
        padding: 0;
      }
      .app-bg-gradient {
        padding:5% 1%;
        overflow: hidden;
        height: 100vh;
      }
      .back {
        font-size: 90px;
        line-height: 90px;
        top: 50px;
        left: inherit;
        right:50px;
      }
      .btn-bg1 {
        width: 420px !important;
      }
      .btn-bg2 {
        width: 412px !important;
      }
      .btn-bg2 button.login {
        width: 410px !important;
      }
      .reports-btn.btn-bg1 {
        width: 450px !important;
      }
      .reports-btn .btn-bg2 {
        width: 440px !important;
      }
      .reports-btn .btn-bg2 button.login {
        width: 430px !important;
      }
      .transaction-data > div:first-child {
        width: 20%;
      }
      .transaction-data > div:nth-child(2) {
        width: 30%;
      }
      .transaction-data > div:nth-child(3) {
        width: 15%;
      }
      .transaction-data > div:nth-child(4) {
        width: 20%;
      }
      .transaction-data > div:last-child {
        width: 15%;
      }
      .error-msg {
        font-size: 70px;
        width: 40vw;
        height: 20vh;
      }
      div[dir='rtl'] .sort-section > div:first-child select, div[dir='rtl'] .sort-section > div:first-child input {
        margin-left: initial;
        margin-right: 30px;
      }
      div[dir='rtl'] .sort-section > div > div:not(:last-child) {
        margin-left: 30px;
      }
  }
  @media screen and (min-width: 1200px) and (min-height: 904px) {
    .full-height {
      height: 92% !important;
    }
    .sort-section > div:first-child select, .sort-section > div:first-child input {
      padding: 0 20px 0 10px;
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/Reports/reports.vue